import { render, staticRenderFns } from "./my_order.vue?vue&type=template&id=2a3cd08a&scoped=true&"
import script from "./my_order.vue?vue&type=script&lang=js&"
export * from "./my_order.vue?vue&type=script&lang=js&"
import style0 from "./my_order.vue?vue&type=style&index=0&id=2a3cd08a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a3cd08a",
  null
  
)

export default component.exports